<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-calendar text-primary mr-2"></i>
                    Agenda
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-col lg="12" sm="12">

                <b-row>
                    <v-date-picker
                        class="w-100"
                        mode='range'
                        v-model='date'
                        :attributes="attributes"
                        is-double-paned
                        is-inline
                        show-caps>
                    </v-date-picker>
                </b-row>

                <b-row class="py-2 justify-content-center">
                    <template v-if="!marked">
                        <b-card class="my-2" header="Seleccione rango">
                            <b-form inline @submit.prevent="store">

                                <label class="mx-sm-2" for="start">Inicio </label>
                                <b-input
                                    id="start"
                                    type="text"
                                    v-model="item.startDate"
                                    placeholder="..."
                                    disabled
                                    required></b-input>

                                <label class="ml-4 mr-sm-2" for="end">Fin</label>
                                <b-input
                                    id="end"
                                    type="text"
                                    v-model="item.endDate"
                                    placeholder="..."
                                    disabled
                                    required></b-input>

                                <label class="ml-4 mr-sm-2" for="title">Motivo</label>
                                <b-input
                                    id="title"
                                    type="text"
                                    v-model="item.title"
                                    placeholder="Motivo de ausencia"
                                    class="mr-2"
                                    required></b-input>

                                <button class="btn btn-primary pl-2 ml-4">Guardar</button>

                            </b-form>
                        </b-card>
                    </template>
                    <template v-else="marked"></template>
                </b-row>

                <b-row>
                    <b-card header="Periodos de ausencia">
                        <b-table
                            :hover="true"
                            :striped="true"
                            :bordered="true"
                            :small="true"
                            :fixed="true"
                            responsive="sm"
                            :items="items"
                            :fields="items_fields">
                            <template slot="start_date" slot-scope="row">
                                {{ formatDate(row.item.start_date) }}
                            </template>
                            <template slot="end_date" slot-scope="row">
                                {{ formatDate(row.item.end_date) }}
                            </template>
                            <template slot="uuid" slot-scope="row">
                                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                                <b-button
                                    size="sm"
                                    @click.stop="remove(row.item.uuid)"
                                    v-b-modal.newItem
                                    class="mr-1 bg-danger">
                                    <i class="fa fa-trash"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-card>
                </b-row>

            </b-col>
        </b-row>
    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import {setupCalendar, Calendar, DatePicker} from 'v-calendar'
    import 'v-calendar/lib/v-calendar.min.css'
    import {mapActions, mapGetters} from "vuex";

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    })

    const today = new Date();

    export default {
        name: 'listSchedule',
        components: {
            'v-date-picker': DatePicker,
            'v-calendar': Calendar,
        },
        mounted() {
            this.me = this.authUser().roles;
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.item.startDate = new Date(this.date.start).toLocaleDateString('zh-Hans-CN').split('/').join("-");
            this.item.endDate = new Date(this.date.end).toLocaleDateString('zh-Hans-CN').split('/').join("-");
            this.getSchedule();
            this.date = null;
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                ],
                item: {
                    startDate: null,
                    endDate: null,
                    title: '',
                    uuid: 0,
                },
                items_fields: {
                    start_date: {
                        label: 'Fecha de Inicio',
                        sortable: true
                    },
                    end_date: {
                        label: 'Fecha de Fin',
                        sortable: true
                    },
                    title: {
                        label: 'Motivo',
                    },
                    uuid: {
                        label: 'Borrar',
                        class: 'fit text-center'
                    },
                },
                date: {
                    start: new Date(today.getFullYear(), today.getMonth(), today.getDay() + 14),
                    end: new Date(today.getFullYear(), today.getMonth(), today.getDay() + 21)
                },
                items: [],
                marked: false,
                me: null,
            }
        },
        methods: {
            ...mapGetters([
                'authUser',
            ]),

            getSchedule() {

                this.$_loadingMixin_showLoading();

                let self = this;

                axios.get('me/schedules')
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == "200") {
                            response.data.forEach(function (data) {
                                data['date'] = {
                                    start: new Date(data.start_date),
                                    end: new Date(data.end_date)
                                }
                            });
                            self.items = response.data;
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        console.log(error.code, "<-2");
                        self.showErrorMsg();
                    });
            },

            store() {

                let self = this;
                let path = "me/schedules";
                let type = "post";
                let resp = 201;

                axios({method: type, url: path, data: this.item})
                    .then(function (response) {
                        if (response.status == resp) {
                            self.showSuccessMsg();
                            self.date = null;
                            self.item.title = "";
                            self.getSchedule();
                        }
                    })
                    .catch(function (error) {
                        self.showErrorMsg();
                    });
            },

            remove(uuid) {

                this.$_loadingMixin_showLoading();

                let self = this;

                swal({
                    title: '¿Desea eliminar el rango seleccionado?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {
                        axios.delete('me/schedules/' + uuid)
                            .then(function (response) {
                                self.$_loadingMixin_hideLoading();
                                if (response.status == "200") {
                                    self.showSuccessMsg({
                                        title: 'Operación Completada',
                                        message: 'Registro eliminado con éxito'
                                    });
                                    self.getSchedule()
                                }
                            })
                            .catch(function (error) {
                                self.$_loadingMixin_hideLoading();
                                self.showErrorMsg();
                            });
                    }
                });
            },

            formatDate(date) {
                let d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;

                return [year, month, day].join('-');
            },

            isMarked(start, end) {
                return this.items.map(function (data, index, _arr) {
                    if ((data.date.start <= start && start <= data.date.end) || (data.date.start <= end && end <= data.date.end)) {
                        return data
                    } else if (data.date.start >= start && end >= data.date.end) {
                        console.log(data.date.start, data.date.end)
                        return data
                    }
                }).filter(function (sel) {
                    return sel;
                })[0]
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Periodo guardado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Algo salió mal'
            },
            showPrivilegesMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'No puede borrar este periodo'
            }
        },
        watch: {
            'date.end': function () {

                if (this.date === null) {
                    return;
                }

                this.item.endDate = new Date(this.date.end).toLocaleDateString('zh-Hans-CN').split('/').join("-")
                this.marked = this.isMarked(this.date.start, this.date.end);

                if (this.marked) {
                    this.item = this.marked;
                    if (this.item.date.start <= today) {
                        if (this.me != null && this.me.filter(r => r.name == 'ROLE_ADMIN')) {
                            this.remove(this.marked.uuid)
                        } else {
                            this.showPrivilegesMsg();
                        }
                    } else {
                        this.remove(this.marked.uuid);
                    }
                }
            },
            'date.start': function () {
                if (this.date === null) {
                    return;
                }
                this.item.startDate = new Date(this.date.start).toLocaleDateString('zh-Hans-CN').split('/').join("-")
            }
        },
        computed: {
            'item.startDate': function () {
                return new Date(this.date.start.getFullYear(), this.date.start.getMonth(), this.date.start.getDay())
            },
            'item.endDate': function () {
                return new Date(this.date.end).toLocaleDateString('zh-Hans-CN').split('/').join("-")
            },

            attributes() {
                return this.items.map(t => ({
                    key: `todo.${t.uuid}`,
                    highlight: {
                        backgroundColor: '#ff8080',
                        // Other properties are available too, like `height` & `borderRadius`
                    },
                    dates: t.date,
                    customData: t,
                }));
            },
        },
    }
</script>

<style>
    .fit {
        width: 60px;
        white-space: nowrap;
    }
</style>
